// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"c852b572","17":"33df089b","60":"6703d890","283":"65bd81fe","561":"65bd81fe","562":"65bd81fe","842":"50a10101","848":"65bd81fe","931":"0f2fbb12"}[chunkId] + ".chunk.css";
};